import React from 'react';
import {StyleSheet, View} from 'react-native';
import {ActivityIndicator} from 'trpc-react-native-ui';
import ConfirmationModalBody from './ConfirmationModalBody';
import PropTypes from 'prop-types';
import {RCTModal} from '../Modal';
import I18n from '../../../lib/i18n';

var styles = StyleSheet.create({
  modalBackground: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
});

const Modal = props => (
  <RCTModal
    animationType="fade"
    transparent
    visible={props.opened ?? false}
    onRequestClose={props.cancel}>
    <View style={styles.modalBackground}>
      {props.loading ? (
        <ActivityIndicator />
      ) : (
        <ConfirmationModalBody
          onConfirm={props.confirm}
          onCancel={props.cancel}
          confirmContent={props.confirmContent}
          title={props.title}
          confirmText={props.confirmText ?? I18n.t('confirm')}
          cancelText={props.cancelText ?? I18n.t('cancel')}
          thirdButtonText={props.thirdButtonText}
          thirdButtonAction={props.thirdButtonAction}>
          {props.children}
        </ConfirmationModalBody>
      )}
    </View>
  </RCTModal>
);

Modal.propTypes = {
  confirm: PropTypes.func,
  cancel: PropTypes.func,
  opened: PropTypes.bool,
  confirmContent: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  loading: PropTypes.bool,
};

export default Modal;
